import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = {
  class: "MaterialPageContainer"
};
const _hoisted_2 = {
  class: "part-container today-part"
};
const _hoisted_3 = {
  class: "leftCenter mb30"
};
const _hoisted_4 = {
  key: 0,
  class: "wd100 mt16 leftCenter",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_5 = {
  key: 1,
  class: "empty-tips"
};
const _hoisted_6 = {
  class: "part-container history-part"
};
const _hoisted_7 = {
  class: "wd100 mt16 leftCenter",
  style: {
    "flex-wrap": "wrap"
  }
};
const _hoisted_8 = {
  class: "wd100 bothCenter"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ButtonDialog = _resolveComponent("ButtonDialog");
  const _component_MaterialCard = _resolveComponent("MaterialCard");
  const _component_el_date_picker = _resolveComponent("el-date-picker");
  const _component_el_col = _resolveComponent("el-col");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_DialogCustomView = _resolveComponent("DialogCustomView");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_cache[10] || (_cache[10] = _createElementVNode("span", {
    class: "ft20 boldFont title mr16"
  }, "今日素材", -1)), _createVNode(_component_ButtonDialog, {
    "btn-name": "创建网桥链接",
    "btn-id": 15,
    onFresh: $options.onNetBridgeCreated
  }, null, 8, ["onFresh"])]), $data.todayList && $data.todayList.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.todayList, t => {
    return _openBlock(), _createBlock(_component_MaterialCard, {
      key: `today_${t.id}`,
      data: t
    }, null, 8, ["data"]);
  }), 128))])) : (_openBlock(), _createElementBlock("div", _hoisted_5, " 暂无新增素材 "))]), _createElementVNode("div", _hoisted_6, [_cache[25] || (_cache[25] = _createElementVNode("span", {
    class: "ft20 boldFont title"
  }, "历史素材", -1)), _createVNode(_component_el_row, {
    class: "ft14 search-form"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[11] || (_cache[11] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "创建时间：", -1)), _createVNode(_component_el_date_picker, {
        modelValue: $data.search.createdTime,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.search.createdTime = $event),
        type: "daterange",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        "value-format": "YYYY-MM-DD",
        format: "YYYY-MM-DD",
        shortcuts: $data.shortcuts
      }, null, 8, ["modelValue", "shortcuts"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[12] || (_cache[12] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "业务分类：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.bizType,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.search.bizType = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.bizTypes, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[13] || (_cache[13] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "创作人：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.creatorId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.search.creatorId = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.users, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.value,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[14] || (_cache[14] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "平台：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.platform,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.search.platform = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.platforms, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[16] || (_cache[16] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "素材域：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.scopeId,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.search.scopeId = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          value: "0",
          label: "全部"
        }, {
          default: _withCtx(() => _cache[15] || (_cache[15] = [_createTextVNode("全部")])),
          _: 1
        }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.scopes, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `biz${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[20] || (_cache[20] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "爆款：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.boom,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.search.boom = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_el_option, {
          value: "",
          label: "全部"
        }, {
          default: _withCtx(() => _cache[17] || (_cache[17] = [_createTextVNode("全部")])),
          _: 1
        }), _createVNode(_component_el_option, {
          value: true,
          label: "是"
        }, {
          default: _withCtx(() => _cache[18] || (_cache[18] = [_createTextVNode("是")])),
          _: 1
        }), _createVNode(_component_el_option, {
          value: false,
          label: "否"
        }, {
          default: _withCtx(() => _cache[19] || (_cache[19] = [_createTextVNode("否")])),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[21] || (_cache[21] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "任意搜：", -1)), _createVNode(_component_el_input, {
        modelValue: $data.search.search,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.search.search = $event),
        placeholder: "支持多维模糊搜索",
        style: {
          "width": "80%"
        }
      }, null, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_cache[22] || (_cache[22] = _createElementVNode("span", {
        class: "mr12",
        style: {
          "width": "110px"
        }
      }, "分类标签：", -1)), _createVNode(_component_el_select, {
        modelValue: $data.search.tag,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.search.tag = $event),
        filterable: ""
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.params.tags, b => {
          return _openBlock(), _createBlock(_component_el_option, {
            key: `tag${b.id}`,
            value: b.id,
            label: b.label
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(b.label), 1)]),
            _: 2
          }, 1032, ["value", "label"]);
        }), 128))]),
        _: 1
      }, 8, ["modelValue"])]),
      _: 1
    }), _createVNode(_component_el_col, {
      span: 6,
      class: "leftCenter mb12 opd6 box"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_button, {
        style: {
          "width": "100px"
        },
        type: "primary",
        onClick: $options.historySearch
      }, {
        default: _withCtx(() => _cache[23] || (_cache[23] = [_createTextVNode("搜索")])),
        _: 1
      }, 8, ["onClick"]), _createVNode(_component_el_button, {
        style: {
          "width": "100px"
        },
        onClick: $options.resetSearch
      }, {
        default: _withCtx(() => _cache[24] || (_cache[24] = [_createTextVNode("重置")])),
        _: 1
      }, 8, ["onClick"])]),
      _: 1
    })]),
    _: 1
  }), _createElementVNode("div", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.historyList, t => {
    return _openBlock(), _createBlock(_component_MaterialCard, {
      key: `today_${t.id}`,
      data: t
    }, null, 8, ["data"]);
  }), 128))]), _createVNode(_component_el_row, {
    class: "rightCenter mt20"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      background: "",
      onCurrentChange: $options.onPageChange,
      onSizeChange: $options.onPageSizeChange,
      layout: "total, sizes, prev, pager, next, jumper",
      "current-page": $data.page,
      "default-page-size": 64,
      "page-size": $data.search.pageSize,
      "page-sizes": [8, 16, 32, 64],
      total: $data.total
    }, null, 8, ["onCurrentChange", "onSizeChange", "current-page", "page-size", "total"])]),
    _: 1
  })])]), _createVNode(_component_DialogCustomView, {
    "visible-control": $data.netBridgeVisible,
    onClose: _cache[9] || (_cache[9] = $event => $data.netBridgeVisible = false),
    title: "网桥链接",
    width: "800px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", null, _toDisplayString($data.netBridgeUrl), 1), _createElementVNode("button", {
      class: "ml12",
      onClick: _cache[8] || (_cache[8] = (...args) => $options.copyNetBridge && $options.copyNetBridge(...args))
    }, "复制")])]),
    _: 1
  }, 8, ["visible-control"])], 64);
}